/* 劉備傳・第 8 章：雒城（建安十九年，214）
 * 史實：《三國志·龐統傳》「進圍雒縣，統率衆攻城，爲流矢所中，卒，時年三十六。先主痛惜，言則流涕。」
 *       （落鳳坡、龐統騎劉備的白馬是演義。）
 * 流程：1. 操作龐統攻城：城頭弓手放箭前地上先畫紅圈；到城門下站著撞門。龐統中流矢是劇情，躲不掉。
 *       2. 改操作劉備：接著撞開城門，擊退守將劉璝，雒城破即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, boss, swapPlayer, TROOPS, PEOPLE, rout, vanish } from '../kit.ts';
import { CITY, GATE, CAMP } from '../maps/luocheng.ts';

const LV = 13, GATE_HP = 100;
const YI = { spec: TROOPS.huangzu, name: '益州兵', hp: 480, maxHp: 480, atk: 28 };

export default {
  id: 'liubei-8', map: 'luocheng', hero: 'pangtong',
  title: '第 8 章　雒城', year: '建安十九年（214）',
  brief: {
    quote: [{ text: '進圍雒縣，統率衆攻城，爲流矢所中，卒，時年三十六。', src: '《三國志·蜀書·龐統傳》' }],
    text: '劉備入蜀，與劉璋翻臉，一路打到雒城。劉璋的兒子劉循與部將劉璝據城死守，圍城將近一年。（落鳳坡是演義。）',
    goals: ['龐統：冒著箭雨攻城（中流矢是劇情）', '劉備：撞開城門', '擊退守將劉璝'],
  },
  words: { ally: '劉備軍', foe: '益州兵' },
  stars: [
    { text: '龐統倒下前城門已經撞開一半', ok: (m) => m.vars.gateAtFall != null && m.vars.gateAtFall <= GATE_HP / 2 },
    { text: '劉備軍折損不超過 12 人', ok: (m) => m.stats.lost <= 12 },
    { text: '換成劉備後 90 秒內破城', ok: (m) => m.vars.winT != null && m.vars.winT < 90 },
  ],
  steps: [
    { // 1. 龐統攻城
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = GATE[0]; me.y = GATE[1] + 900;
        V.gate = GATE_HP; V.t0 = w.t; V.volT = 2;
        V.men = Array.from({ length: 10 }, (_, i) => { const u = m.recruit(me.x - 200 + (i % 5) * 100, me.y + 100 + Math.floor(i / 5) * 80, '劉備軍'); u.spec = TROOPS.shu; m.join(u, me); return u; });
        m.gate('gate', GATE[0], GATE[1], 150, 'citygate', null, { hp: GATE_HP, hp0: GATE_HP });
        V.out = Array.from({ length: 6 }, (_, i) => m.foe('huangjin', GATE[0] - 250 + (i % 3) * 250, GATE[1] + 250 + Math.floor(i / 3) * 120, YI));
        m.line('龐統', '雒城圍了快一年了，今日一舉攻下！跟我上！');
        m.after(4, () => m.line('提示', '城頭的箭落下前地上先有紅圈。到城門下站著不動，就是撞門。'));
        m.mark('gate', GATE[0], GATE[1] + 120, '城門');
        m.obj('gate', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, g = m.gates.find((x) => x.id === 'gate');
        archers(m, w, dt);
        m.chanAt(me, 'ram', GATE[0], GATE[1] + 120, 170, 9999, '撞門', () => {}, { hurt: false });
        if (me.chan && me.chan.key === 'ram') V.gate = Math.max(0, V.gate - dt * 2.4);
        g.hp = V.gate;
        m.get('gate').text = `撞開城門（${Math.round(100 - (100 * V.gate) / GATE_HP)}%）`;
        return w.t - V.t0 > 40 || (V.gate <= GATE_HP * 0.35 && w.t - V.t0 > 15);
      },
    },
    { // 2. 爲流矢所中
      enter(m, w) {
        const V = m.vars, tong = w.player;
        V.gateAtFall = V.gate;
        tong.chan = null; tong.hp = 1; tong.st.stun = 9;
        w.fx({ k: 'spark', x: tong.x, y: tong.y - 40, col: '#ff4030' });
        m.big('軍師中箭！');
        m.card('統率衆攻城，爲流矢所中，卒，時年三十六。', '《龐統傳》');
        m.after(2, () => vanish(w, tong));
        const lb = ally(w, 'liubei', CAMP[0], CAMP[1] - 600, LV);
        swapPlayer(w, lb);
        for (const u of m.alive(V.men)) m.join(u, lb);
        m.after(4, () => m.card('先主痛惜，言則流涕。', '《龐統傳》'));
        m.after(8, () => m.line('劉備', '士元……此城不破，誓不還！'));
        V.t2 = w.t;
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars, g = m.gates.find((x) => x.id === 'gate');
        archers(m, w, dt);
        m.chanAt(me, 'ram', GATE[0], GATE[1] + 120, 170, 9999, '撞門', () => {}, { hurt: false });
        if (me.chan && me.chan.key === 'ram') V.gate = Math.max(0, V.gate - dt * 2.4);
        g.hp = V.gate;
        m.get('gate').text = `撞開城門（${Math.round(100 - (100 * V.gate) / GATE_HP)}%）`;
        return V.gate <= 0;
      },
    },
    { // 3. 入城：擊退劉璝
      enter(m, w) {
        const me = w.player, V = m.vars;
        me.chan = null;
        m.ungate('gate'); m.done('gate'); m.unmark('gate');
        m.big('城門破了！');
        V.gui = boss(w, PEOPLE.huangzu, CITY.x, CITY.y - 100, { name: '劉璝', hp: 2800, atk: 42, armor: 8 });
        V.inner = m.camp(CITY.x, CITY.y, [['huangjin', 6]], 300).map((u) => Object.assign(u, YI, { hp: 480 }));
        for (let i = 0; i < 8; i++) { const p = SG.MAP.nearestFree(GATE[0] - 150 + (i % 4) * 100, GATE[1] + 250 + Math.floor(i / 4) * 80); const u = m.recruit(p[0], p[1], '劉備軍'); u.spec = TROOPS.shu; m.join(u, me); } // 大軍隨後湧入
        m.mark('gui', V.gui.x, V.gui.y, '劉璝', false, V.gui);
        m.obj('gui', '擊退守將劉璝');
      },
      tick(m, w) {
        const V = m.vars;
        if (V.gui.hp > V.gui.maxHp * 0.3 && V.gui.alive) return false;
        V.winT = w.t - V.t2;
        m.done('gui'); m.unmark('gui');
        rout(m, w, V.inner.concat(V.out), [CITY.x, 300]);
        if (V.gui.alive) { V.gui.untargetable = true; V.gui.home = [CITY.x, 300]; }
        m.big('雒城破！');
        V.done = true;
        m.after(2, () => m.win());
        return true;
      },
    },
    { tick() { return false; } },
  ],
  always(m, w) {
    if (m.vars.done) { w.player.hp = Math.max(w.player.hp, 1); return; }
    if (!w.player.alive && m.i !== 1) m.lose(m.i >= 2 ? '劉備陣亡' : '龐統陣亡');
  },
};

// 城頭弓手：攻城的人靠近城牆時，往他腳下射一陣
function archers(m, w, dt) {
  const V = m.vars, me = w.player;
  V.volT -= dt;
  if (V.volT > 0 || !me.alive || me.y > GATE[1] + 900) return;
  V.volT = 1.8;
  m.strike(me.x + (SG.rand() - 0.5) * 380, me.y + (SG.rand() - 0.5) * 220, 120, 1.2, 50, 0);
}
